import React from "react";
import { connect } from "react-redux";
import { Nav, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
//import { FormattedMessage } from "react-intl";

import "./UserNavItem.css";
import avatars from "../../images/avatars";
import JumpNumberTransition from "../TextTransition/JumpNumberTransition";

const UserNavItem = (props) => {
  if (props.isSignedIn) {
    return (
      <Nav.Link as={Link} to="/user" id="user-welcome">
        {/* <FormattedMessage
          id="header.welcome"
          defaultMessage="Hello, {name}"
          values={{name: props.userName.trim() === "" ? props.googleUserName.trim().substr(0,10) : props.userName.trim().substr(0,10)}}
        />
        &nbsp; */}
        <Image 
          id="avartar-header"
          src={avatars[props.avatarId]}
          style={{
            backgroundColor: props.backgroundColor,
            borderColor: props.borderColor,
          }}
          thumbnail
        />
        &nbsp;<i className="far fa-star text-warning"/>
          <span className="text-warning font-weight-bold">
            <JumpNumberTransition value={props.stars} />
          </span>
      </Nav.Link>
    );
  }
  
  return null;
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    isSignedIn: state.user.isSignedIn,
    googleUserName: state.user.userName,
    userName: state.userSettings.userName,
    avatarId: state.userSettings.avatarId, 
    backgroundColor: state.userSettings.avatarBackground, 
    borderColor: state.userSettings.avatarBorderColor,
    stars: state.userRecords.coins
  };
}

export default connect(mapStateToProps)(UserNavItem);